import { Flex, List } from 'antd';
import { FC, ReactElement } from 'react';

import { CopyableText, SwitchSuccess } from '@/common/components';
import { BaseQueryParams } from '@/common/interfaces';

import { ReferralLinksListComponent, useGetAllReferralLinksQuery } from '@/modules/Sites';

interface Props {
  referralLinks: BaseQueryParams<typeof useGetAllReferralLinksQuery>['data'];
  disableControlButtons: boolean;
  handleSetEditingListMode: () => void;
}

export const ReferralLinksListView: FC<Props> = ({
  referralLinks,
  disableControlButtons,
  handleSetEditingListMode,
}) => {
  return (
    <div style={{ overflowY: 'auto', maxHeight: 760, marginInline: -24, paddingInline: 24, marginTop: -12 }}>
      <ReferralLinksListComponent
        dataSource={ referralLinks }
        disabled={ disableControlButtons }
        onButtonClick={ handleSetEditingListMode }
        renderItem={ (item): ReactElement => (
          <List.Item>
            <List.Item.Meta
              title={
                <CopyableText textToCopy={ item.url }>
                  { item.url }
                </CopyableText>
              }
              description={
                <Flex justify="space-between" align="center">
                  <Flex vertical>
                    <span>Частота появлень: { item.appearanceFrequency }%</span>
                    <span>Актуальних переходів: { item.currentTransitionCount }</span>
                    <span>Всього переходів: { item.totalTransitionCount }</span>
                  </Flex>

                  <div>
                    <SwitchSuccess checked={ item.isActive }/>
                  </div>
                </Flex>
              }
            />
          </List.Item>
        ) }
      />
    </div>
  );
};
